import { api } from '@/lib/api';

export type UserAddress = {
  id: string;
  label: string;
  address: string;
  landmark: string | null;
  city: string;
  state: string;
  pincode: string;
  phone: string | null;
  access_notes: string | null;
  latitude: number | null;
  longitude: number | null;
  is_default: boolean;
  created_at: string;
};

export type AddressInput = {
  label: string;
  address: string;
  landmark?: string | null;
  city: string;
  state: string;
  pincode: string;
  phone?: string | null;
  access_notes?: string | null;
  /**
   * The map pin. Send BOTH or NEITHER — the API rejects a lone ordinate, because one on its own
   * cannot place a pin and would strand a rider with a coordinate pointing nowhere.
   *
   * On update, `null` for both clears a pin that was set by mistake.
   */
  latitude?: number | null;
  longitude?: number | null;
  is_default?: boolean;
};

export async function fetch_addresses(): Promise<UserAddress[]> {
  const res = await api.get<UserAddress[]>('/user/addresses');
  return res.data;
}

export async function create_address(input: AddressInput): Promise<UserAddress> {
  const res = await api.post<UserAddress>('/user/addresses', input);
  return res.data;
}

export async function update_address(
  id: string,
  input: Partial<AddressInput>,
): Promise<UserAddress> {
  const res = await api.patch<UserAddress>(`/user/addresses/${id}`, input);
  return res.data;
}

export async function delete_address(id: string): Promise<void> {
  await api.delete(`/user/addresses/${id}`);
}

export async function set_default_address(id: string): Promise<UserAddress> {
  const res = await api.post<UserAddress>(`/user/addresses/${id}/default`);
  return res.data;
}
